import PropTypes from 'prop-types';
import type { StyledComponent, StyledComponentProps } from 'styled-components';
import styled from 'styled-components';

import type { BorderProps, CommonProps, LayoutProps } from './constants';
import { BORDER, COMMON, LAYOUT } from './constants';
import theme from './theme';

type Props = CommonProps &
  BorderProps &
  LayoutProps & {
    // new <img> attribute not referenced yet in React.ImgHTMLAttributes
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img
    loading?: 'lazy' | 'eager';
  };

// HACK
// necessary to have the proper types for width and height
// otherwise we end up with a mix of img.width and LayoutProps.width
type FullImageProps = Omit<StyledComponentProps<'img', any, Props, never>, 'width' | 'height'> &
  Pick<LayoutProps, 'width' | 'height'>;
// using "mark" as it doesn't have specific attributes,
// so that only props from FullImageProps will be applied
type ImageWithOverriddenProps = StyledComponent<'mark', any, FullImageProps, never>;

const Image: ImageWithOverriddenProps = styled.img<Props>`
  display: block;
  max-width: 100%;
  height: auto;
  ${LAYOUT} ${COMMON} ${BORDER};
`;

Image.defaultProps = { theme };

Image.propTypes = {
  ...LAYOUT.propTypes,
  ...COMMON.propTypes,
  ...BORDER.propTypes,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Image.displayName = 'Image';

export { Image };
